var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tripadvisor-score-component flex items-center space-x-2 -ml-2"},[_c('img',{attrs:{"src":("https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/" + (_vm.rating.toFixed(1)) + "-MCID-5.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }